import { WidgetOptions } from '@sprinklr/stories/widget/WidgetOptions';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { LabelTextFormat, LegendOrientation, SmartSize } from '@sprinklr/stories/widget/types';
import { observable } from 'mobx';
import { DecimalFormat } from 'utils/Number/NumberUtils';
import { FontCase } from 'models/Theme/Theme';

export interface SmallMultiplesPieChartWidgetOptions extends WidgetOptions {
    data?: any;
    emptyWedgeColor?: string;
    blacklist?: string[];
    legendOrientation?: LegendOrientation;
    maxItems?: number;
    minWedgeRatio?: number;
    legendSize?: number;
    legendWrap?: boolean;
    arrangement: 'legacy' | 'grid' | 'gridDefined';
    gridLayout?: {
        gap: number;
        columns: number;
        rows: number;
    };
}

export class SmallMultiplesPieChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements SmallMultiplesPieChartWidgetOptions {
    @observable labelSize = 12;
    @observable labelTextFormat: LabelTextFormat = 'clamp';
    @observable labelLineClamp = true;
    @observable labelLineClampValue = 2;
    @observable labelWrapText = false;
    @observable textFitMin = 10;
    @observable textFitMax = 30;

    @observable showMetricValue = true;
    @observable metricValueType: 'value' | 'ratio' = 'ratio';
    @observable metricValueSize = 15;
    @observable metricValueFormat: DecimalFormat = '1k';

    @observable showInnerRadius = true;
    @observable innerRadiusSize = 46;

    @observable zoom = 50;
    @observable offsetX = 0;
    @observable offsetY = 0;

    @observable showTimeRemainder = true;
    @observable emptyWedgeColor = 'rgba(255, 255, 255, .3)';
    @observable blacklist: string[] = [];
    @observable showOtherItems = false;
    @observable maxItems = 9;

    @observable showLegend = true;
    @observable legendOrientation: LegendOrientation = 'bottom';
    @observable legendWidth = 25;
    @observable legendHeight = 25;
    @observable showLegendRatio = true;
    @observable legendPercentageSize = 32;
    @observable legendPercentageFormat: DecimalFormat = '1.2k';
    @observable showLegendValue = false;
    @observable legendValueSize = 32;
    @observable legendValueFormat: DecimalFormat = '1k';
    @observable legendWrap = false;
    @observable showLegendHeader = false;
    @observable showLegendName = true;
    @observable legendNameSize = 20;

    @observable arrangement = 'legacy' as SmallMultiplesPieChartWidgetOptions['arrangement'];
    @observable gridLayout = {
        gap: 10,
        columns: 3,
        rows: 3,
    };

    @observable smartSize: SmartSize = {
        enabled: false,
        mode: 'responsive',
        size: 'xl',
        baseline: {
            labelSize: 12,
            metricValueSize: 15,
            legendValueSize: 32,
            legendPercentageSize: 32,
            legendHeight: 25,
            legendWidth: 25,
            legendNameSize: 20,
        },
        optionDefaults: {},
        breakpoints: {
            xs: {
                options: {},
            },
            s: {
                options: {},
            },
        },
    };
}
